var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasicLineChart',{attrs:{"chart-data":_vm.chartData,"grid-lines":_vm.gridLines,"css-classes":'chart'}})
}
var staticRenderFns = []

export { render, staticRenderFns }